import React, { useEffect, useState } from "react";
import { Card, Tag, Avatar, Spin,Modal, Upload, Button, Input, message,Form , InputNumber ,Alert ,Progress} from "antd";
import { CameraOutlined,UploadOutlined ,EditOutlined , ExclamationCircleOutlined  } from "@ant-design/icons";
import ImgCrop from "antd-img-crop";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import dayjs from "dayjs";

const ProfileInstructor = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);


  const [isPhotoModalOpen, setIsPhotoModalOpen] = useState(false);
const [file, setFile] = useState(null);
const [preview, setPreview] = useState(null);

const [editOpen, setEditOpen] = useState(false);
const [form] = Form.useForm();

const [docEditOpen, setDocEditOpen] = useState(false);
const [docForm] = Form.useForm();
const [resumeFile, setResumeFile] = useState(null);

const [uploadProgress, setUploadProgress] = useState(0);
const [updatingDocs, setUpdatingDocs] = useState(false);

const [bankEditOpen, setBankEditOpen] = useState(false);
const [bankForm] = Form.useForm();
const [bankUpdating, setBankUpdating] = useState(false);
const [bankImageFile, setBankImageFile] = useState(null);
const [bankImagePreview, setBankImagePreview] = useState(null);

useEffect(() => {
  if (profile) {
    form.setFieldsValue({
      Domain: profile.Domain,
      ProgramName: profile.ProgramName,
      PreviousCompany: profile.PreviousCompany,
      Experience: profile.Experience,
    });
  }
}, [profile]);


useEffect(() => {
  if (profile) {
    docForm.setFieldsValue({
      PanCardNumber: profile.PanCardNumber,
      AadharCardNumber: profile.AadharCardNumber,
    });
  }
}, [profile]);

useEffect(() => {
  if (profile) {
    bankForm.setFieldsValue({
      BankAccountHolderName: profile.BankAccountHolderName,
      BankAccountNumber: profile.BankAccountNumber,
      BankName: profile.BankName,
      BankBranch: profile.BankBranch,
      IFSCCode: profile.IFSCCode,
    });
  }
}, [profile]);

  const token = localStorage.getItem("token");

  const fetchProfile = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/user/instructor/profile/view`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
 
      if (res.data.success) {
        setProfile(res.data.data);
        localStorage.setItem('profilePhotoUrl',res.data.data.ProfilePhotoUrl)       
        
     
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  const handleUpload = async () => {
  if (!file) return message.error("Please select an image");

  const formData = new FormData();
  formData.append("ProfilePhoto", file);

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/user/upload-profile-photo`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (res.data.success) {
      toast.success("Profile photo updated");
      setIsPhotoModalOpen(false);
      setFile(null);
      setPreview(null);
      fetchProfile(); // refresh profile
    }
  } catch (err) {
    toast.error("Upload failed");
  }
};

const handleUpdate = async (values) => {
  try {
    const res = await axios.put(
      `${process.env.REACT_APP_API_URL}/user/instructor/update-professional`,
      values,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (res.data.success) {
      toast.success("Updated Professional Details successfully");
      setEditOpen(false);
      fetchProfile(); // 🔥 refresh
    }
  } catch (err) {
    toast.error("Update failed");
  }
};

const handleDocUpdate = async (values) => {
  try {
    setUpdatingDocs(true);
    setUploadProgress(0);

    const formData = new FormData();
    formData.append("PanCardNumber", values.PanCardNumber);
    formData.append("AadharCardNumber", values.AadharCardNumber);

    if (resumeFile) {
      formData.append("Resume", resumeFile);
    }

    const res = await axios.put(
      `${process.env.REACT_APP_API_URL}/user/instructor/update-documents`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percent);
        },
      }
    );

    if (res.data.success) {
      toast.success("Documents updated");
      setDocEditOpen(false);
      setResumeFile(null);
      fetchProfile();
    }

  } catch (err) {
    toast.error("Update failed");
  } finally {
    setUpdatingDocs(false);
    setUploadProgress(0);
  }
};

const handleBankUpdate = async (values) => {
  try {
    setBankUpdating(true);
    setUploadProgress(0);

    const formData = new FormData();

    Object.keys(values).forEach((k) => formData.append(k, values[k]));

    if (bankImageFile) {
      formData.append("BankImage", bankImageFile);
    }

    const res = await axios.put(
      `${process.env.REACT_APP_API_URL}/user/instructor/update-bank`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (e) => {
          const percent = Math.round((e.loaded * 100) / e.total);
          setUploadProgress(percent);
        },
      }
    );

    if (res.data.success) {
      toast.success("Bank details updated");
      setBankEditOpen(false);
      setBankImageFile(null);
      setBankImagePreview(null);
      fetchProfile();
    }

  } catch (err) {
    toast.error("Update failed");
  } finally {
    setBankUpdating(false);
    setUploadProgress(0);
  }
};

const isDocumentsMissing =
  !profile?.PanCardNumber ||
  !profile?.AadharCardNumber ||
  !profile?.ResumeUrl;

  const getProgressBar = (percent) => {
  const totalBlocks = 45;
  const filledBlocks = Math.round((percent / 100) * totalBlocks);

  const bar =
    "█".repeat(filledBlocks) +
    "░".repeat(totalBlocks - filledBlocks);

  return `${bar} ${percent}%`;
};

const formatAadhar = (num) => {
  if (!num) return "";

  return num
    .replace(/\s+/g, "")           // remove existing spaces
    .replace(/(\d{4})(?=\d)/g, "$1 "); // add space every 4 digits
};

const isProfessionalMissing =
  !profile?.Domain ||
  !profile?.ProgramName ||
  !profile?.PreviousCompany ||
  !profile?.Experience;

  const isBankMissing =
  !profile?.BankAccountHolderName ||
  !profile?.BankAccountNumber ||
  !profile?.BankName ||
  !profile?.BankBranch ||
  !profile?.IFSCCode;




  if (loading)
    return (
      <div className="flex justify-center mt-20">
        <Spin size="large" />
      </div>
    );

  if (!profile) return <p>No profile found</p>;

  return (
    <div className="px-6 py-10 mx-auto space-y-6 max-w-7xl">

      <ToastContainer
                                          position="bottom-left"
                                          autoClose={5000}
                                          hideProgressBar={true}
                                          newestOnTop={false}
                                          closeOnClick
                                          rtl={false}
                                          pauseOnFocusLoss
                                          draggable
                                          pauseOnHover
                                          theme="dark"
                                          className="!mb-6 !ml-4"
                                          toastClassName="!inline-flex !items-center !whitespace-nowrap !bg-black !text-white !px-4 !py-2 !rounded-lg !w-auto !min-w-0 !shadow-lg"
                                        />

      {/* HEADER */}
     <Card className="p-3 border-0 rounded-lg shadow-md bg-slate-900">

  <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">

    {/* LEFT SECTION */}
    <div className="flex items-center gap-5">

      {/* AVATAR */}
      <div className="relative group">

        <div className="p-[2px] rounded-full bg-gradient-to-r from-blue-500 to-purple-500">
          <Avatar
            size={90}
            src={profile.ProfilePhotoUrl}
            className="bg-white cursor-pointer"
            onClick={() => setIsPhotoModalOpen(true)}
          >
            {profile.FullName?.[0]}
          </Avatar>
        </div>

        {/* HOVER EDIT */}
        <div
          onClick={() => setIsPhotoModalOpen(true)}
          className="absolute inset-0 flex items-center justify-center transition rounded-full opacity-0 cursor-pointer bg-black/60 group-hover:opacity-100"
        >
          <CameraOutlined className="text-lg text-white" />
        </div>

      </div>

      {/* USER INFO */}
      <div>

        <h1 className="text-2xl font-semibold tracking-tight text-white">
          {profile.FullName}
        </h1>

        <p className="text-sm text-gray-200 mt-0.5">
          {profile.Email}
        </p>

        {/* TAGS */}
        <div className="flex flex-wrap gap-2 mt-3">

          <Tag className="px-3 py-1 text-xs font-medium text-blue-600 border border-blue-100 rounded-md bg-blue-50">
            {profile.Role}
          </Tag>

          <Tag
            className={`px-3 py-1 text-xs font-medium rounded-md border ${
              profile.InstructorStatus === "ACTIVE"
                ? "bg-green-50 text-green-600 border-green-100"
                : "bg-red-50 text-red-600 border-red-100"
            }`}
          >
           Instructor Status : {profile.InstructorStatus}
          </Tag>

          <Tag
            className={`px-3 py-1 text-xs font-medium rounded-md border ${
              profile.PlatformAccess === "ACTIVE"
                ? "bg-purple-50 text-purple-600 border-purple-100"
                : "bg-orange-50 text-orange-600 border-orange-100"
            }`}
          >
           Platform access : {profile.PlatformAccess}
          </Tag>

        </div>
      </div>

    </div>

    {/* RIGHT SECTION (OPTIONAL ACTIONS) */}
    <div className="flex gap-2">

      <Button
        onClick={() => setIsPhotoModalOpen(true)}
        className="text-white rounded-lg bg-cyan-700 hover:bg-cyan-600"
      >
        Update Photo
      </Button>

    </div>

  </div>

</Card>

      {/* BASIC INFO */}
      <Card
  title={
    <div>
      <h2 className="text-lg font-semibold text-slate-900">
        Basic Information
      </h2>
      <p className="text-xs text-gray-500">
        Your personal contact details
      </p>
    </div>
  }
  className="p-3 border-0 rounded-lg shadow-sm bg-gradient-to-br from-orange-50 to-white"
>

  <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

    {/* PHONE */}
    <div className="p-4 bg-white border shadow-sm rounded-xl border-sky-100">
      <p className="text-xs font-medium tracking-wide uppercase text-sky-600">
        Phone Number
      </p>

      <p className="mt-1 text-sm font-semibold text-slate-800">
        {profile?.PhoneNumber || (
          <span className="text-red-500">Not Provided</span>
        )}
      </p>
    </div>

    {/* COUNTRY */}
    <div className="p-4 bg-white border border-blue-100 shadow-sm rounded-xl">
      <p className="text-xs font-medium tracking-wide text-blue-600 uppercase">
        Country
      </p>

      <p className="mt-1 text-sm font-semibold text-slate-800">
        {profile?.Country || (
          <span className="text-red-500">Not Provided</span>
        )}
      </p>
    </div>

  </div>

</Card>

      {/* PROFESSIONAL */}
     <Card
  title={
    <div>
      <h2 className="text-lg font-semibold text-slate-900">
        Professional Details
      </h2>
      <p className="text-xs text-gray-500">
        Your career and experience information
      </p>
    </div>
  }
  className="p-3 border-0 rounded-lg shadow-sm bg-gradient-to-br from-blue-50 to-white"
  extra={
    <Button
      icon={<EditOutlined />}
      type="text"
      onClick={() => setEditOpen(true)}
      className="font-medium text-blue-600 rounded-lg hover:bg-blue-100"
    >
      Edit
    </Button>
  }
>

  {/* 🚨 BANNER */}
  {isProfessionalMissing && (
    <Alert
      icon={<ExclamationCircleOutlined />}
      message={
        <span className="font-semibold">
          Professional Details Required
        </span>
      }
      description="Please update your domain, program, company, and experience to complete your profile."
      type="warning"
      showIcon
      className="mb-5 border border-yellow-200 rounded-xl bg-yellow-50"
      action={
        <Button
          size="small"
          type="primary"
          onClick={() => setEditOpen(true)}
        >
          Update Now
        </Button>
      }
    />
  )}

  {/* CONTENT */}
  <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

    {/* DOMAIN */}
    <div className="p-4 bg-white border border-blue-100 shadow-sm rounded-xl">
      <p className="text-xs font-medium tracking-wide text-blue-600 uppercase">
        Domain
      </p>
      <p className="mt-1 text-sm font-semibold text-slate-800">
        {profile?.Domain || (
          <span className="text-red-500">Not Provided</span>
        )}
      </p>
    </div>

    {/* PROGRAM */}
    <div className="p-4 bg-white border border-purple-100 shadow-sm rounded-xl">
      <p className="text-xs font-medium tracking-wide text-purple-600 uppercase">
        Program
      </p>
      <p className="mt-1 text-sm font-semibold text-slate-800">
        {profile?.ProgramName || (
          <span className="text-red-500">Not Provided</span>
        )}
      </p>
    </div>

    {/* COMPANY */}
    <div className="p-4 bg-white border border-green-100 shadow-sm rounded-xl">
      <p className="text-xs font-medium tracking-wide text-green-600 uppercase">
        Previous Company
      </p>
      <p className="mt-1 text-sm font-semibold text-slate-800">
        {profile?.PreviousCompany || (
          <span className="text-red-500">Not Provided</span>
        )}
      </p>
    </div>

    {/* EXPERIENCE */}
    <div className="p-4 bg-white border border-orange-100 shadow-sm rounded-xl">
      <p className="text-xs font-medium tracking-wide text-orange-600 uppercase">
        Experience
      </p>
      <p className="mt-1 text-sm font-semibold text-slate-800">
        {profile?.Experience
          ? `${profile.Experience} Years`
          : <span className="text-red-500">Not Provided</span>}
      </p>
    </div>

  </div>
</Card>

      {/* DOCUMENTS */}
     <Card
  title={
    <div>
      <h2 className="text-lg font-semibold text-slate-900">
        Documents
      </h2>
      <p className="text-xs text-gray-500">
        Identity and verification documents
      </p>
    </div>
  }
  className="p-3 border-0 rounded-lg shadow-sm bg-gradient-to-br from-purple-50 to-white"
  extra={
    <Button
      icon={<EditOutlined />}
      type="text"
      onClick={() => setDocEditOpen(true)}
      className="font-medium text-purple-600 rounded-lg hover:bg-purple-100"
    >
      Edit
    </Button>
  }
>

  {/* 🚨 ALERT */}
  {isDocumentsMissing && (
    <Alert
      icon={<ExclamationCircleOutlined />}
      message={<span className="font-semibold">Documents Required</span>}
      description="Please update your PAN, Aadhar, and Resume to complete your profile."
      type="warning"
      showIcon
      className="mb-5 border border-yellow-200 rounded-xl bg-yellow-50"
      action={
        <Button
          size="small"
          type="primary"
          onClick={() => setDocEditOpen(true)}
        >
          Update Now
        </Button>
      }
    />
  )}

  {/* CONTENT */}
  <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

    {/* PAN */}
    <div className="p-4 bg-white border border-blue-100 shadow-sm rounded-xl">
      <p className="text-xs font-medium tracking-wide text-blue-600 uppercase">
        PAN Card
      </p>
      <p className="mt-1 text-sm font-semibold text-slate-800">
        {profile?.PanCardNumber
          ?  profile.PanCardNumber
          : <span className="text-red-500">Not Provided</span>}
      </p>
    </div>

    {/* AADHAR */}
    <div className="p-4 bg-white border border-indigo-100 shadow-sm rounded-xl">
      <p className="text-xs font-medium tracking-wide text-indigo-600 uppercase">
        Aadhar Card
      </p>
      <p className="mt-1 text-sm font-semibold text-slate-800">
        {profile?.AadharCardNumber
          ? formatAadhar(profile.AadharCardNumber)
          : <span className="text-red-500">Not Provided</span>}
      </p>
    </div>

    {/* RESUME */}
    <div className="p-4 bg-white border border-green-100 shadow-sm rounded-xl md:col-span-2">
      <p className="text-xs font-medium tracking-wide text-green-600 uppercase">
        Resume
      </p>

      {profile?.ResumeUrl ? (
        <div className="flex items-center justify-between mt-2">
          <p className="text-sm text-gray-600">Resume uploaded</p>

          <a
            href={profile.ResumeUrl}
            target="_blank"
            rel="noreferrer"
            className="text-sm font-medium text-green-600 underline hover:text-green-700"
          >
            View Resume
          </a>
        </div>
      ) : (
        <p className="mt-1 text-sm text-red-500">
          Resume not uploaded
        </p>
      )}
    </div>

  </div>

</Card>

      {/* BANK DETAILS */}
     <Card
  title={
    <div>
      <h2 className="text-lg font-semibold text-slate-900">
        Bank Details
      </h2>
      <p className="text-xs text-gray-500">
        Payment and account information
      </p>
    </div>
  }
  className="p-3 border-0 rounded-lg shadow-sm bg-gradient-to-br from-green-50 to-white"
  extra={
    <Button
      icon={<EditOutlined />}
      type="text"
      onClick={() => setBankEditOpen(true)}
      className="font-medium text-green-600 rounded-lg hover:bg-green-100"
    >
      Edit
    </Button>
  }
>

  {/* 🚨 ALERT */}
  {isBankMissing && (
    <Alert
      icon={<ExclamationCircleOutlined />}
      message={<span className="font-semibold">Bank Details Required</span>}
      description="Please update your bank details and upload proof to receive payments."
      type="warning"
      showIcon
      className="mb-5 border border-yellow-200 rounded-xl bg-yellow-50"
      action={
        <Button
          type="primary"
          size="small"
          onClick={() => setBankEditOpen(true)}
        >
          Update Now
        </Button>
      }
    />
  )}

  {/* CONTENT */}
  <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

    {/* ACCOUNT HOLDER */}
    <div className="p-4 bg-white border border-green-100 shadow-sm rounded-xl">
      <p className="text-xs font-medium tracking-wide text-green-600 uppercase">
        Account Holder
      </p>
      <p className="mt-1 text-sm font-semibold text-slate-800">
        {profile?.BankAccountHolderName || (
          <span className="text-red-500">Not Provided</span>
        )}
      </p>
    </div>

    {/* ACCOUNT NUMBER */}
    <div className="p-4 bg-white border shadow-sm rounded-xl border-emerald-100">
      <p className="text-xs font-medium tracking-wide uppercase text-emerald-600">
        Account Number
      </p>
      <p className="mt-1 text-sm font-semibold text-slate-800">
        {profile?.BankAccountNumber
          ? profile.BankAccountNumber
          : <span className="text-red-500">Not Provided</span>}
      </p>
    </div>

    {/* BANK */}
    <div className="p-4 bg-white border border-teal-100 shadow-sm rounded-xl">
      <p className="text-xs font-medium tracking-wide text-teal-600 uppercase">
        Bank
      </p>
      <p className="mt-1 text-sm font-semibold text-slate-800">
        {profile?.BankName || (
          <span className="text-red-500">Not Provided</span>
        )}
      </p>
    </div>

    {/* BRANCH */}
    <div className="p-4 bg-white border shadow-sm rounded-xl border-cyan-100">
      <p className="text-xs font-medium tracking-wide uppercase text-cyan-600">
        Branch
      </p>
      <p className="mt-1 text-sm font-semibold text-slate-800">
        {profile?.BankBranch || (
          <span className="text-red-500">Not Provided</span>
        )}
      </p>
    </div>

    {/* IFSC */}
    <div className="p-4 bg-white border shadow-sm rounded-xl border-lime-100 md:col-span-2">
      <p className="text-xs font-medium tracking-wide uppercase text-lime-600">
        IFSC Code
      </p>
      <p className="mt-1 text-sm font-semibold text-slate-800">
        {profile?.IFSCCode || (
          <span className="text-red-500">Not Provided</span>
        )}
      </p>
    </div>

  </div>

  {/* 🖼 BANK PROOF IMAGE */}
  {profile?.BankAccountPhotoUrl && (
    <div className="mt-8">
      <p className="mb-2 text-xs font-medium tracking-wide text-gray-500 uppercase">
        Bank Proof Document
      </p>

      <div className="overflow-hidden bg-white border shadow-sm rounded-2xl">
        <img
          src={profile.BankAccountPhotoUrl}
          alt="bank-proof"
          className="object-cover w-full h-64 transition duration-300 hover:scale-[1.02]"
        />
      </div>
    </div>
  )}

</Card>


      {/* STATUS */}
     <Card
  title={
    <div>
      <h2 className="text-lg font-semibold text-slate-900">
        Status & Activity
      </h2>
      <p className="text-xs text-gray-500">
        Your activity and engagement overview
      </p>
    </div>
  }
  className="p-3 border-0 rounded-lg shadow-sm bg-gradient-to-br from-indigo-50 to-white"
>
  <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

    {/* MOCK INTERVIEWS */}
    <div className="p-5 bg-white border border-indigo-100 shadow-sm rounded-xl">
      <p className="text-xs font-medium tracking-wide text-indigo-600 uppercase">
        Mock Interviews Taken
      </p>

      <p className="mt-2 text-2xl font-bold text-slate-900">
        {profile?.MockInterviewsTaken || 0}
      </p>

      <p className="mt-1 text-xs text-gray-500">
        Total interviews conducted
      </p>
    </div>

    {/* FUTURE CARD (EXTENDABLE) */}
    <div className="p-5 bg-white border border-purple-100 shadow-sm rounded-xl">
      <p className="text-xs font-medium tracking-wide text-purple-600 uppercase">
        Activity Status
      </p>

      <p className="mt-2 text-lg font-semibold text-slate-800">
        Active
      </p>

      <p className="mt-1 text-xs text-gray-500">
        Based on recent engagement
      </p>
    </div>

  </div>
</Card>

      {/* TIMELINE */}
      <Card
  title={
    <div>
      <h2 className="text-lg font-semibold text-slate-900">
        Timeline
      </h2>
      <p className="text-xs text-gray-500">
        Your journey and important milestones
      </p>
    </div>
  }
  className="p-3 border-0 rounded-lg shadow-sm bg-gradient-to-br from-orange-50 to-white"
>
  <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

    {/* JOINED DATE */}
    <div className="p-5 bg-white border border-orange-100 shadow-sm rounded-xl">
      <p className="text-xs font-medium tracking-wide text-orange-600 uppercase">
        Joined Date
      </p>

      <p className="mt-2 text-lg font-semibold text-slate-800">
        {profile?.JoinedDate
          ? dayjs(profile.JoinedDate).format("DD MMM YYYY")
          : <span className="text-red-500">Not Available</span>}
      </p>

      <p className="mt-1 text-xs text-gray-500">
        When you joined the platform
      </p>
    </div>

    {/* TENURE (BONUS 🔥) */}
    <div className="p-5 bg-white border shadow-sm rounded-xl border-amber-100">
      <p className="text-xs font-medium tracking-wide uppercase text-amber-600">
        Tenure
      </p>

      <p className="mt-2 text-lg font-semibold text-slate-800">
        {profile?.JoinedDate
          ? `${dayjs().diff(dayjs(profile.JoinedDate), "month")} Months`
          : "N/A"}
      </p>

      <p className="mt-1 text-xs text-gray-500">
        Time on platform
      </p>
    </div>

  </div>
</Card>


      <Modal
  open={isPhotoModalOpen}
  onCancel={() => setIsPhotoModalOpen(false)}
  footer={null}
  centered
  width={500}
  title={
    <span className="text-lg font-semibold text-slate-800">
      Update Profile Photo
    </span>
  }
>

  <div className="space-y-5">

    {/* USER INFO */}
    <div>
      <p className="text-sm text-gray-500">Name</p>
      <Input value={profile.FullName} disabled className="h-10" />
    </div>

    <div>
      <p className="text-sm text-gray-500">Email</p>
      <Input value={profile.Email} disabled className="h-10" />
    </div>

    {/* IMAGE UPLOAD WITH CROP */}
    <div>
      <p className="mb-2 text-sm text-gray-500">
        Upload Profile Photo
      </p>

      <ImgCrop
        rotationSlider
        aspect={1} // square crop
        quality={1}
        modalTitle="Crop Image"
      >
        <Upload
          beforeUpload={(file) => {
            const isImage = file.type.startsWith("image/");
            if (!isImage) {
              message.error("Only image files are allowed");
              return false;
            }

            setFile(file);
            setPreview(URL.createObjectURL(file));
            return false;
          }}
          showUploadList={false}
        >
          <Button icon={<UploadOutlined />} className="w-full h-11">
            Select Image
          </Button>
        </Upload>
      </ImgCrop>

      {/* PREVIEW */}
      {preview && (
        <div className="flex justify-center mt-4">
          <img
            src={preview}
            alt="preview"
            className="object-cover w-32 h-32 border rounded-full"
          />
        </div>
      )}
    </div>

    {/* ACTION BUTTON */}
    <Button
      type="primary"
      block
      className="font-semibold h-11 rounded-xl"
      onClick={handleUpload}
    >
      Upload Profile Photo
    </Button>

  </div>

</Modal>

<Modal
  open={editOpen}
  onCancel={() => setEditOpen(false)}
  footer={null}
  title="Edit Professional Details"
>
  <Form layout="vertical" form={form} onFinish={handleUpdate}>

    <Form.Item label="Domain" name="Domain">
      <Input placeholder="Cyber Security" />
    </Form.Item>

    <Form.Item label="Program Name" name="ProgramName">
      <Input placeholder="Full Stack Security" />
    </Form.Item>

    <Form.Item label="Previous Company" name="PreviousCompany">
      <Input placeholder="TCS / Infosys" />
    </Form.Item>

    <Form.Item label="Experience (Years)" name="Experience">
      <InputNumber min={0} className="w-full" />
    </Form.Item>

    <Button
      type="primary"
      htmlType="submit"
      block
      className="mt-2 h-11"
    >
      Update Details
    </Button>

  </Form>
</Modal>

<Modal
  open={docEditOpen}
  onCancel={() => setDocEditOpen(false)}
  footer={null}
  title="Edit Documents"
>
  <Form layout="vertical" form={docForm} onFinish={handleDocUpdate}>

    <Form.Item
  label="PAN Card Number"
  name="PanCardNumber"
  rules={[
    { required: true, message: "PAN is required" },
    { len: 10, message: "PAN must be exactly 10 characters" },
    {
      pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
      message: "Invalid PAN format (e.g. ABCDE1234F)",
    },
  ]}
>
  <Input
    placeholder="ABCDE1234F"
    maxLength={10}
    onChange={(e) => {
      e.target.value = e.target.value.toUpperCase();
    }}
  />
</Form.Item>

    <Form.Item
  label="Aadhar Card Number"
  name="AadharCardNumber"
  rules={[
    { required: true, message: "Aadhar is required" },
    { len: 12, message: "Aadhar must be 12 digits" },
    {
      pattern: /^[0-9]{12}$/,
      message: "Aadhar must contain only numbers",
    },
  ]}
>
  <Input
    placeholder="XXXX XXXX XXXX"
    maxLength={12}
    onChange={(e) => {
      e.target.value = e.target.value.replace(/\D/g, ""); // only numbers
    }}
  />
</Form.Item>

   <Form.Item label="Upload Resume">

  <Upload
    beforeUpload={(file) => {
      const isPDF = file.type === "application/pdf";
      if (!isPDF) {
        message.error("Only PDF allowed");
        return false;
      }

      setResumeFile(file);
      return false;
    }}
    showUploadList={false}
  >
    <Button className="w-full">
      {resumeFile ? "Replace Resume" : "Upload Resume (PDF)"}
    </Button>
  </Upload>

  {/* 🔹 SHOW NEW FILE */}
  {resumeFile && (
    <p className="mt-2 text-sm text-green-600">
      Selected: {resumeFile.name}
    </p>
  )}

  {/* 🔹 SHOW EXISTING RESUME */}
  {!resumeFile && profile?.ResumeUrl && (
    <div className="flex items-center justify-between mt-2">

      <p className="text-sm text-gray-600">
        Resume already uploaded
      </p>

      <a
        href={profile.ResumeUrl}
        target="_blank"
        rel="noreferrer"
        className="text-sm text-blue-600 underline"
      >
        View
      </a>

    </div>
  )}

  {/* 🔹 NO RESUME */}
  {!resumeFile && !profile?.ResumeUrl && (
    <p className="mt-2 text-sm text-red-500">
      No resume uploaded
    </p>
  )}

 {updatingDocs && uploadProgress > 0 && (
  <div className="p-3 mt-3 bg-black rounded-xl">

    <p className="font-mono text-sm text-green-400">
      {getProgressBar(uploadProgress)}
    </p>

    <p className="mt-1 font-mono text-xs text-gray-400">
      Uploading document...
    </p>

  </div>
)}

</Form.Item>
    <Button
  type="primary"
  htmlType="submit"
  block
  loading={updatingDocs}
  disabled={updatingDocs}
  className="mt-2 h-11"
>
  {updatingDocs ? "Processing..." : "Update Documents"}
</Button>

  </Form>
</Modal>

<Modal
  open={bankEditOpen}
  onCancel={() => setBankEditOpen(false)}
  footer={null}
  title="Edit Bank Details"
  centered
>

  <Form layout="vertical" form={bankForm} onFinish={handleBankUpdate}>

    <Form.Item label="Account Holder Name" name="BankAccountHolderName" rules={[{ required: true }]}>
      <Input />
    </Form.Item>

    <Form.Item label="Account Number" name="BankAccountNumber" rules={[{ required: true }]}>
      <Input maxLength={18} />
    </Form.Item>

    <Form.Item label="Bank Name" name="BankName" rules={[{ required: true }]}>
      <Input />
    </Form.Item>

    <Form.Item label="Branch" name="BankBranch" rules={[{ required: true }]}>
      <Input />
    </Form.Item>

    <Form.Item
      label="IFSC Code"
      name="IFSCCode"
      rules={[
        { required: true },
        { pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/, message: "Invalid IFSC" }
      ]}
    >
      <Input
        maxLength={11}
        onChange={(e) => (e.target.value = e.target.value.toUpperCase())}
      />
    </Form.Item>

    {/* 🔥 IMAGE UPLOAD */}
    <Form.Item label="Upload Bank Proof Image">

      <Upload
        beforeUpload={(file) => {
          if (!file.type.startsWith("image/")) {
            message.error("Only image allowed");
            return false;
          }

          setBankImageFile(file);
          setBankImagePreview(URL.createObjectURL(file));
          return false;
        }}
        showUploadList={false}
      >
        <Button className="w-full">
          {bankImageFile ? "Replace Image" : "Upload Image"}
        </Button>
      </Upload>

      {/* NEW PREVIEW */}
      {bankImagePreview && (
        <div className="mt-3">
          <img
            src={bankImagePreview}
            alt="preview"
            className="object-cover w-32 h-32 border rounded-lg"
          />
        </div>
      )}

      {/* EXISTING */}
      {!bankImagePreview && profile?.BankAccountPhotoUrl && (
        <div className="mt-3">
          <img
            src={profile.BankAccountPhotoUrl}
            alt="existing"
            className="object-cover w-32 h-32 border rounded-lg"
          />
        </div>
      )}

    </Form.Item>

    {/* 🔥 CUSTOM PROGRESS BAR */}
    {bankUpdating && uploadProgress > 0 && (
      <div className="p-3 mt-3 bg-black rounded-xl">
        <p className="font-mono text-sm text-green-400">
          {getProgressBar(uploadProgress)}
        </p>
        <p className="mt-1 font-mono text-xs text-gray-400">
          Uploading bank proof...
        </p>
      </div>
    )}

    {/* 🔥 SUBMIT BUTTON */}
    <Button
      type="primary"
      htmlType="submit"
      block
      loading={bankUpdating}
      disabled={bankUpdating}
      className="mt-4 h-11"
    >
      {bankUpdating ? "Processing..." : "Update Bank Details"}
    </Button>

  </Form>

</Modal>
    </div>
  );
};

export default ProfileInstructor;